module.exports = __webpack_public_path__ + "static/media/payment-bank-edit.7f50da7e.svg";